import React from "react";
import { Typography, Toastify } from "top-brains-ui";
import ActivationImage from "@src/assets/register-success-img.svg";
import styles from "@src/pages/login/expired-activation-link/ExpiredActivationLink.module.scss";
// import { WEBSITE_COLORS } from "@src/styles/ColorConstants";
// import { useSelector } from "react-redux";
// import { useResendActivationLinkMutation } from "@src/api/LoginApiSlice";
// import { capitalizeFirstLetter } from "@src/utils/CommonUtils";
// import GradiantButton from "@src/components/gradiant-btn/GradiantButton";

const ExpiredActivationLink: React.FC = () => {
  // const userId = useSelector(
  //   (state: any) => state.globalSlice?.studentDetails?.id
  // );
  // const [resendActivationLink] = useResendActivationLinkMutation();
  // const handleResendActivation = async () => {
  //   if (!userId) {
  //     alert("User ID not found. Please log in again.");
  //     return;
  //   }
  //   try {
  //     const response = await resendActivationLink({ userId }).unwrap();
  //     toast.success("Success", capitalizeFirstLetter(response?.response));
  //   } catch (error) {
  //     toast.error("Failed to resend activation link. Please try again.");
  //   }
  // };
  return (
    <>
      <div className={styles.container}>
        <div className={styles.msgTitle}>
          <Typography fontWeight="semi-bold" fontSize={26} color="var(--modal-heading-color)" className={styles.activationLinkExpired}>
            Your Activation link is expired
          </Typography>
        </div>

        <div className={styles.imgContainer}>
          <img src={ActivationImage} alt="activation_img" />
        </div>
        <div className={styles.msgBody}>
          <div>
            <Typography fontSize={16} color="var(--modal-body-color)">
              Your activation link has expired!!! <br />
              New activation link has been sent to your email.
            </Typography>
          </div>
        </div>
        {/* <div className={styles.resendBtn}>
          <GradiantButton
            variant="gradient"
            label="Resend Activation Link"
            width="400px"
            onClick={handleResendActivation}
          />
        </div> */}
      </div>
      <Toastify />
    </>
  );
};

export default ExpiredActivationLink;
